import { Box3 as F, Vector3 as c, Triangle as U, Vector2 as w, BufferAttribute as X } from "three";
const l = new F(), o = new c(), d = new c(), v = new c(), z = new U(), r = new w(), m = new w(), u = new w(), s = new c(), h = new c(), V = new c();
function a(n) {
  if (!n.hasAttribute("position"))
    return;
  n.computeBoundingBox(), n.boundingBox.getSize(o);
  const t = Math.min(o.x, o.y, o.z);
  d.set(-t / 2, -t / 2, -t / 2), v.set(t / 2, t / 2, t / 2), l.set(d, v);
  const i = n.getAttribute("position"), y = new X(new Float32Array(i.count * 2), 2);
  for (let e = 0; e < i.count; e += 3) {
    z.setFromAttributeAndIndices(i, e, e + 1, e + 2);
    const { a: f, b: p, c: A } = Y(l, t, z);
    y.setXY(e, f.x, f.y), y.setXY(e + 1, p.x, p.y), y.setXY(e + 2, A.x, A.y);
  }
  y.needsUpdate = !0, n.setAttribute("uv", y);
}
function Y(n, t, { a: i, b: y, c: e }) {
  return h.copy(y).sub(i), V.copy(y).sub(e), s.crossVectors(h, V).normalize(), s.x = Math.abs(s.x), s.y = Math.abs(s.y), s.z = Math.abs(s.z), s.y > s.x && s.y > s.z ? (r.x = (i.x - n.min.x) / t, r.y = (n.max.z - i.z) / t, m.x = (y.x - n.min.x) / t, m.y = (n.max.z - y.z) / t, u.x = (e.x - n.min.x) / t, u.y = (n.max.z - e.z) / t) : s.x > s.y && s.x > s.z ? (r.x = (i.z - n.min.z) / t, r.y = (i.y - n.min.y) / t, m.x = (y.z - n.min.z) / t, m.y = (y.y - n.min.y) / t, u.x = (e.z - n.min.z) / t, u.y = (e.y - n.min.y) / t) : s.z > s.y && s.z > s.x && (r.x = (i.x - n.min.x) / t, r.y = (i.y - n.min.y) / t, m.x = (y.x - n.min.x) / t, m.y = (y.y - n.min.y) / t, u.x = (e.x - n.min.x) / t, u.y = (e.y - n.min.y) / t), {
    a: r,
    b: m,
    c: u
  };
}
export {
  a as applyBoxUV
};
//# sourceMappingURL=index.js.map
